<div class="container">
    <div class="config-tab-title-area">
        <smart-icon name="filter-o" class="light"></smart-icon>
        <span class="h3-regular config-tab-title">{{'dashboard.filter_your_data' | stringLiterals}}</span>
    </div>
    <div class="filter-area">
        <filter-panel [config]="filterConfig"></filter-panel>
    </div>
    <div class="row">
        <tam-field-selector [config]="fieldConfig"></tam-field-selector>
    </div>
</div>